<template>
  <div id="app">
    <base-header />
    <keep-alive include="CruiseSearch,CruiseDetail">
        <router-view></router-view>
    </keep-alive>
    <FloatMenu v-if="isShowFloatMenu"/>
    <base-footer />
    <privacy-modal v-model="isShowPrivacy" :user-agreement-info="userAgreementInfo" @submit="submitAgreePrivacyPolicy"></privacy-modal>
  </div>
</template>

<script>
const BaseHeader = () => import('./components/BaseHeader.vue')
const BaseFooter = () => import('./components/BaseFooter.vue')
const FloatMenu = () => import('./components/FloatMenu/FloatMenu.vue')
const PrivacyModal = () => import('./components/Common/PrivacyModal.vue')
import { isMobile, gioRecord } from '@/utilities/tools'
import Cookies from 'js-cookie'
import api from "@/api";
const AGREE_PRIVACY = "AGREE_PRIVACY";
export default {
  name: 'App',
  components: {
    BaseHeader,
    BaseFooter,
    FloatMenu,
    PrivacyModal
  },
  data() {
    return {
      isShowFloatMenu: false,
      routeName: "",
      userName: "",
      isShowPrivacy: false,
      userAgreementInfo: null
    }
  },
  created() {
    let linkStr = window.location.href;
    const PRIVACY_PATTERNS = [
      '/legalinfo/privacy',
      '/legalinfo/repeat',
      '/Rccl.UserCenter/Privacy',
      '/Rccl.UserCenter/RewardRule'
    ];

    let isPrivacyRelated = false;
    for (let i = 0; i < PRIVACY_PATTERNS.length; i++) {
      if (linkStr.indexOf(PRIVACY_PATTERNS[i]) >= 0) {
        isPrivacyRelated = true;
        break;
      }
    }

    if (!isPrivacyRelated) {
      this.initPrivacyPolicy();
    }

    this.getNrpData()
  },
  beforeMount() {
    if (isMobile()) {
      return location.href = `${process.env.VUE_APP_MOBILE_URL}${location.pathname}${location.search}` 
    }

    const userToken = this.$store.state.user.userToken
    if (!userToken || userToken.length == 0) {
      const auth = Cookies.get('authed', { path: "/" })
      if (auth == "1" && location.href.toLowerCase().indexOf("auth") < 0) {
        const authUrl = encodeURIComponent(`${process.env.VUE_APP_BASE_URL}/Orchard.Rccl.Users/Auth/Index`)
        const redirectUrl = encodeURIComponent(location.href)
        const autoLoginUrl = `${process.env.VUE_APP_API_BASE_URL}/Rccl.Campaign/RedirectToTui/Auth`
        + `?authUrl=${authUrl}&redirectUrl=${redirectUrl}&campaignId=${process.env.VUE_APP_API_KEY}`
        Cookies.remove('authed', { path: '/'})
        return location.href = autoLoginUrl
      }
    }
    this.routeName = this.$router.currentRoute.name.toLowerCase()
    try {
      if(window && window.gio){
        const route = this.$route
        const query = route.query
       
        if(query && query.cs6 && query.cs6.length > 0){
          window.gio('app.set', 'MessageID', query.cs6.toString())
        }
      }
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    // 初始化是否同意过最新隐私政策
    async initPrivacyPolicy() {
      this.userName = this.$store.state.user.userToken;
      const IsInitPrivacyPolicy = window.sessionStorage.getItem("IsInitPrivacyPolicy") && window.sessionStorage.getItem("IsInitPrivacyPolicy") === "true";
      // let isAgreePrivacy = window.sessionStorage.getItem(AGREE_PRIVACY);
      // 用户已经登录进行验证
      if(this.userName && !IsInitPrivacyPolicy) {
        const { success, data, errMsg } = await api.user.getUserAgreeVersionIsEffective(this.userName);
        if(success) {
          window.sessionStorage.setItem(AGREE_PRIVACY, data ? "true" : "false");
          console.log('initPrivacyPolicy--', data)
          this.userAgreementInfo = data;
          this.isShowPrivacy = data.isAny;
          window.sessionStorage.setItem("IsInitPrivacyPolicy", "true");
        } else {
          window.sessionStorage.setItem("IsInitPrivacyPolicy", "false");
          this.$alert.show(errMsg)
        }
        // 已经同意最新隐私政策 true-同意，false-不同意
        // if(isAgreePrivacy === "true") {
        //   this.isShowPrivacy = false;
        // } else {
        //   const { success, data, errMsg } = await api.user.getUserVersionIsEffective(this.userName);
        //   if(success) {
        //     window.sessionStorage.setItem(AGREE_PRIVACY, data ? "true" : "false");
        //     this.isShowPrivacy =! data;
        //   } else {
        //     this.$alert.show(errMsg)
        //   }
        // }
      } else {
        this.isShowPrivacy = false;
      }
    },
    /**
     * 同意隐私政策提交
     * @param isAgree true-同意，false-不同意
     * @param type 1-用户协议，2-隐私政策, 3-游享荟TC
     */
    async submitAgreePrivacyPolicy({ isAgree, type }) {
      if(isAgree) {
        const { success, errMsg } = await api.user.agreeToTheLastAgreement({
          userName: this.userName,
          userAgreementType: type
        });
        console.log(success)
        if(success) {
          window.sessionStorage.setItem(AGREE_PRIVACY, "true");
          this.isShowPrivacy = false;
          this.userAgreementInfo = null;
        } else {
          this.$alert.show(errMsg)
        }
      } else {
        this.logout();
      }
    },
    // 退出
    logout() {
      this.isShowPrivacy = false;
      this.userAgreementInfo = null;
      gioRecord('track', 'evt_MainMenu', {
        menu:8,
        subMenu:5,
        desUrl:''
      })
      window.sessionStorage.setItem(AGREE_PRIVACY, "null");
      this.$store.commit("REMOVE_USER_TOKEN");
      localStorage.removeItem('isAcceptPersonalRecommend');
      Cookies.remove("authed", { path: "/" });
      location.reload();
    },
    checkIsShowFloatMenu() {
      if (typeof window != 'undefined') {
        let currentPath = location.href.toLowerCase()
        const ignorePath = ['rccl.booking', 'rccl.usercenter', 'rccl.users']
        for (let i = 0; i < ignorePath.length; i++) {
          if (currentPath.indexOf(ignorePath[i]) >= 0) {
            this.isShowFloatMenu = false
            return
          }
        }
        this.isShowFloatMenu = true
      }
      
    },
    // 获取收费退订和常规退订文案
    async getNrpData(){
      const {success,data} = await api.booking.getGuestPolicy()
      this.$loading.hide()
      if(success){
        this.$store.commit("SET_NRP_DATA_NEW", data);
      }
    }

  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo
    }
  },
  watch: {
    $route (to) {
      this.routeName = to.name.toLowerCase()
    },
    routeName () {
      this.checkIsShowFloatMenu()
    },
    userInfo (userInfo) {
      if (window && window.gio && userInfo && userInfo.cmsId > 0) {
        window.gio('setUserId', userInfo.cmsId)
        window.gio('app.set', 'ID', userInfo.cmsId);
      }
    }
  }
}
</script>

<style>
#app {
    width: 100%;
    min-width: 1280px;
    /* overflow-x: hidden; */
  font-family:
    "Darwin",
    "FZLanTingHeiS-M-GB",
    "方正兰亭中黑简体",
    sans-serif;
}
</style>
